<template>
  <div>

    <v-dialog v-model="dialog" persistent width="800" scrollable>

      <form @submit.prevent="save">
        <v-card :loading="btnLoading">

          <v-card-title>
            {{ title }}
            <v-spacer/>
            <v-icon @click="close">mdi-close</v-icon>
          </v-card-title>

          <v-divider/>

          <v-card-text class="pa-10">

            <v-text-field class="mb-3"
                          outlined
                          dense
                          label="Nom (FR)"
                          v-model="form.name.fr"
                          :error-messages="errors['name.fr']"
                          hint="Nom principal affiché en français"
                          persistent-hint
            />

            <v-text-field class="mb-3"
                          outlined
                          dense
                          label="Name (EN)"
                          v-model="form.name.en"
                          :error-messages="errors['name.en']"
                          hint="English title for international users"
                          persistent-hint
            />

            <v-text-field class="mb-3"
                          outlined
                          dense
                          label="الاسم (AR)"
                          v-model="form.name.ar"
                          :error-messages="errors['name.ar']"
                          hint="العنوان باللغة العربية"
                          persistent-hint
            />


            <v-textarea class="mb-3"
                        outlined
                        label="Description (FR)"
                        v-model="form.description.fr"
                        :error-messages="errors['description.fr']"
                        rows="2"
                        hint="Description détaillée en français"
                        persistent-hint
            />

            <v-textarea class="mb-3"
                        outlined
                        label="Description (EN)"
                        v-model="form.description.en"
                        rows="2"
                        hint="Detailed description in English"
                        persistent-hint
            />

            <v-textarea class="mb-3"
                        outlined
                        hide-details="auto"
                        label="الوصف (AR)"
                        v-model="form.description.ar"
                        rows="2"
                        hint="الوصف الكامل باللغة العربية"
                        persistent-hint
            />


            <v-radio-group
                hide-details="auto"
                v-model="form.type"
                :error-messages="errors.type"
                label="Type *"
                row
                hint="Choisissez le type de calcul de l'objectif"
                persistent-hint
            >
              <v-radio label="Montant" value="amount"/>
              <v-radio label="Quantité" value="quantity"/>
            </v-radio-group>



            <v-checkbox
                v-model="form.is_active"
                label="Actif"
                color="green"
                hint="Active ou désactive cet objectif"
                persistent-hint
            />

          </v-card-text>

          <v-divider/>

          <v-card-actions>
            <v-spacer/>
            <v-btn depressed
                   color="success"
                   :loading="btnLoading"
                   type="submit"
            >
              <v-icon left>mdi-content-save</v-icon>
              Sauvegarder
            </v-btn>
          </v-card-actions>

        </v-card>
      </form>

    </v-dialog>

  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  data() {
    return {
      dialog: false,
      btnLoading: false,
      errors: {},
      form: {
        name: {fr: null, en: null, ar: null},
        description: {fr: null, en: null, ar: null},
        is_active: true,
        type: 'amount'
      },
      typeItems: [
        {value: "amount", label: "Montant"},
        {value: "quantity", label: "Quantité"},
      ],
      title: ""
    };
  },

  methods: {
    open(item = null) {
      this.errors = {};

      const emptyName = {fr: null, en: null, ar: null};
      const emptyDesc = {fr: null, en: null, ar: null};

      if (item) {
        this.title = "Modifier un objectif";

        this.form = {
          ...item,
          name: {
            ...emptyName,
            ...(item.name || {})
          },
          description: {
            ...emptyDesc,
            ...(item.description || {})
          },
          type: item.type || "amount",
          is_active: item.is_active ?? true,
        };
      } else {
        this.title = "Ajouter un objectif";

        this.form = {
          name: {...emptyName},
          description: {...emptyDesc},
          type: "amount",
          is_active: true
        };
      }

      this.dialog = true;
    },

    close() {
      this.dialog = false;
    },

    save() {
      this.btnLoading = true;
      this.errors = {};

      const request = this.form.id
          ? HTTP.put(`/v1/opus/objectives/${this.form.id}`, this.form)
          : HTTP.post(`/v1/opus/objectives`, this.form);

      request
          .then(() => {
            this.$emit("refresh");
            this.$successMessage = "Enregistré avec succès.";
            this.close();
          })
          .catch(err => {
            this.errors = err.response?.data?.errors || {};
          })
          .finally(() => {
            this.btnLoading = false;
          });
    }
  }
};
</script>